module.exports = __webpack_public_path__ + "img/43.a2806e88.jpg";